export default __webpack_public_path__ + "static/media/jackpot-ms.33cfc72a.webp";